export enum StorageKeys {
  VMSToken = 'vms-token',
  ParticipantSid = 'participantSid',
  TenantId = 'tenantId',
  tlaConfig = 'tlaConfig',
  StartAnotherVisitUrl = 'startAnotherVisitUrl',
}
